const STEPS = [
  { title: "Qualify the Homeowner", desc: "A soft credit check is run with your authorization, through a compliant third party." },
  { title: "Qualify the Home", desc: "Roof inspection and structural review to confirm the home is a fit." },
  { title: "HOA Approval", desc: "Required only if your community's HOA has a review process." },
  { title: "Submit Package to Utility", desc: "Interconnection paperwork is sent to Dominion Energy, Rappahannock Electric Cooperative, or your utility." },
  { title: "Permitting", desc: "Local city and county permits are filed and approved." },
  { title: "Installation", desc: "A professional ION Solar crew performs the installation — typically a one-day install." },
  { title: "Final Inspection & Activation", desc: "Utility inspection and PTO (permission to operate) — the moment the system goes live." },
];

export default function InstallationTimeline() {
  return (
    <section className="py-20 md:py-28 bg-[#F7F4EB]" data-testid="installation-timeline-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">The Installation Journey</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            Seven steps. One clear path.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg max-w-2xl">
            Here's what a residential solar install typically looks like, from first conversation to activation. Your own project timeline is tracked privately in the customer portal — this is the general educational overview.
          </p>
        </div>

        <ol className="mt-12 relative">
          <div className="absolute left-4 md:left-6 top-2 bottom-2 w-px bg-[#E5E0D8]" />
          {STEPS.map((s, i) => (
            <li key={i} className="relative pl-14 md:pl-20 pb-8 last:pb-0" data-testid={`install-step-${i + 1}`}>
              <div className="absolute left-0 top-0 w-9 h-9 md:w-12 md:h-12 rounded-full bg-white border border-[#E5E0D8] flex items-center justify-center">
                <span className="font-mono-metric text-sm md:text-base font-semibold text-[#B45309]">{i + 1}</span>
              </div>
              <div className="card-warm p-6">
                <div className="font-mono-metric text-xs tracking-widest text-[#B45309] mb-2">STEP {String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-serif-display text-xl text-[#0F382C]">{s.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
